<div class="header row">
  <h2>SSL Certificates</h2>
  <div class="header-buttons row">
    <button matButton="filled" (click)="openInstallSSLDialog()">
      <fa-icon [icon]="['fas', 'bookmark']" size="lg"></fa-icon>
      Install SSL Certificate
    </button>
    <button matButton="outlined" (click)="openImportSSLDialog()">
      <fa-icon [icon]="['fas', 'file-import']" size="lg"></fa-icon>
      Import SSL Certificate
    </button>
  </div>
</div>

<mat-card appearance="outlined" class="ssl-certificates">
  <app-table
    #table
    [columns]="certificatesColumns"
    [dataSource]="certificates()"
    [totalCount]="certificates().length"
    [expandableRows]="true"
  >
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">
        <app-status-label [status]="toStatus(element.status)"></app-status-label>
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let element">
        <div class="buttons">
          @if (element.status === 'active') {
            <button
              matRipple
              class="button"
              matTooltip="Renew SSL Certificate"
              [matTooltipShowDelay]="500"
              matTooltipPosition="above"
              (click)="renewCertificate(element.id)"
            >
              <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg"></fa-icon>
            </button>
          } @else {
            <button
              matRipple
              class="button"
              matTooltip="Preview SSL Error"
              [matTooltipShowDelay]="500"
              matTooltipPosition="above"
              [disabled]="!element.logs.length"
              (click)="table.toggle(element)"
            >
              <fa-icon [icon]="['fas', 'triangle-exclamation']" size="lg"></fa-icon>
            </button>
          }
          <button
            matRipple
            class="button"
            matTooltip="SSL Info - Aliases, Cert & Key, enable/ disable auto renewal"
            [matTooltipShowDelay]="500"
            matTooltipPosition="above"
            (click)="openCertificateInfoDialog(element)"
          >
            <fa-icon [icon]="['fas', 'info-circle']" size="lg"></fa-icon>
          </button>
          <button
            matRipple
            class="button"
            matTooltip="Delete SSL Certificate"
            [matTooltipShowDelay]="500"
            matTooltipPosition="above"
            (click)="deleteCertificate(element)"
          >
            <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-template #expandedRow let-row>
      @if (row.logs[0]) {
        <div class="expanded-row row">
          <span [innerHTML]="row.logs[0].message"></span>
          <button matButton="filled" (click)="renewCertificate(row.id)">
            <fa-icon [icon]="['fas', 'arrows-rotate']" size="sm"></fa-icon>
            Retry
          </button>
        </div>
      }
    </ng-template>
  </app-table>
</mat-card>
